var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrighthiveImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1444 314",
    height: 314,
    width: 1444,
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    cliPath: "url(#8c28189b-78fb-41ef-8ebc-780c05fc8d59_comp-m7126yt6)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#13b5da39-5533-440a-8487-0dc851ba86f4_comp-m7126yt6)",
    d: "m-736.683 37.302.241-.434 39.803-68.992h79.171l39.562-68.557h79.171l39.561-68.557h80.136l.241.435 39.369 68.122h78.205l39.562-68.557h79.171l39.561-68.557h79.171l39.61-68.557h80.136l.241.435 39.368 68.122h79.171l.242.435 39.32 68.122h78.206l39.561-68.557h79.171l39.562-68.557h80.184l39.609 68.557h79.171l39.61 68.557h78.206l39.61-68.557h80.136l39.609 68.557h79.175l39.61 68.557h78.2l39.61-68.557h80.19l39.56 68.557h79.17l.24.435 39.85 68.99-40.09 69.426h-79.17l-39.56 68.557h-79.18l-39.6 68.557h-80.14l-.24-.434-39.37-68.123h-78.206l-39.61 68.557h-79.171l-39.61 68.557h-79.171l-39.609 68.557h-80.136l-.241-.434-39.321-68.123h-79.171l-.241-.434-39.32-68.123h-78.206l-39.61 68.557h-79.171l-39.609 68.557h-80.184l-.242-.434-39.32-68.123h-79.17l-.242-.434-39.368-68.123h-78.207l-39.561 68.557h-80.184l-.241-.434-39.321-68.123h-79.17l-.242-.434-39.368-68.123h-78.206l-39.561 68.557h-80.185l-.241-.434-39.32-68.123h-79.171l-.241-.434-39.851-68.991h.096Zm277.123 68.557-39.079-67.689h-78.206l-22.627 39.127-16.5 28.562 39.079 67.736h78.206l39.079-67.736h.048Zm-24.702-90.943-12.93 22.386 39.079 67.688h78.206l22.145-38.307 16.983-29.43-39.128-67.736h-78.206l-26.149 45.35v.049Zm125.39-80.04-19.539 33.869 5.114 8.829 34.013 58.907h78.158l39.127-67.736-39.127-67.737h-78.158l-19.539 33.868h-.049Zm231.386 10.663-13.412 23.206 39.079 67.736h78.206L-1.227-2.308l16.741-28.947-39.127-67.737h-78.206l-25.715 44.53h.048Zm105.32-45.351 39.128 67.688h78.206l39.079-67.737-39.08-67.736H16.963L-22.165-99.86v.048Zm250.781-22.965-13.219 22.916 39.079 67.69h78.206l39.079-67.69-18.092-31.359-20.987-36.377h-78.206l-25.86 44.82Zm224.294 22.965 39.079 67.688h78.206l39.079-67.688-39.079-67.737h-78.206l-39.079 67.737Zm257.1-33.869L690.47-99.812l32.855 56.833 6.272 10.855h78.206l39.079-67.688-19.539-33.869-19.54-33.868h-78.206l-19.539 33.868h-.049Zm138.272 34.689-39.079 67.689 39.079 67.736h78.206l39.079-67.737-39.079-67.688h-78.206Zm237.559 0-39.12 67.689 19.53 33.868 19.54 33.868H1164l39.08-67.737-19.54-33.868L1164-99.04h-78.21l.05.048ZM967.062-30.435l-39.079 67.737 31.697 54.903 7.382 12.785h78.208l39.13-67.737-30.06-52.056-9.07-15.68h-78.208v.048ZM728.053 105.859l-39.127-67.737h-78.158l-39.079 67.737 39.079 67.736h78.158l39.127-67.736Zm-276.592 67.736 39.079-67.736-30.78-53.263-8.347-14.426h-78.206l-2.895 5.066-36.184 62.671 19.298 33.434 19.781 34.303h78.206l.048-.049Zm-198.434-67.736L213.948 38.17h-78.206l-39.079 67.69 39.079 67.736h78.206l39.079-67.736ZM-1.227 134.806l16.741-28.947-39.127-67.689h-78.206l-39.079 67.689 39.079 67.736h78.206l22.386-38.789Zm96.395-29.816 39.079-67.688-39.08-67.737H16.963L-8.32 13.372l-13.798 23.881 39.127 67.689h78.206l-.048.048Zm159.307 0h78.206l38.644-66.868.483-.82-3.715-6.465-35.364-61.272h-78.206l-25.86 44.82-13.219 22.917 39.079 67.688h-.048Zm315.719 0 39.079-67.737-32.904-57.026-6.175-10.71h-78.206l-19.54 33.868-19.539 33.868 30.78 53.264 8.347 14.425h78.206l-.048.048Zm159.355 0h78.206l39.079-67.737-39.079-67.736h-78.206l-19.54 33.868-19.539 33.868 39.127 67.737h-.048ZM610.768-98.992l-39.079 67.689 19.54 33.868 19.539 33.868h78.158l39.127-67.737-32.855-56.881-6.272-10.855h-78.158v.048Zm-159.307 0h-78.206l-39.079 67.689 39.079 67.736h78.206l39.079-67.737-39.079-67.688Zm-315.767 0L96.615-31.255l39.079 67.736H213.9l22.917-39.706 16.162-28.03L213.9-98.992h-78.206Zm-356.246 68.557-39.078 67.737 39.078 67.688h78.207l39.079-67.688-39.079-67.737h-78.207Zm-118.78 204.03h78.158l22.916-39.706 16.163-28.03-39.128-67.689h-78.157l-22.145 38.307-16.983 29.43 39.128 67.737.048-.049Zm236.066.821-39.128-67.737H-220.6l-22.916 39.706-16.163 28.031 39.079 67.736h78.206l39.128-67.736Zm120.228 67.736h78.206l22.916-39.706 16.163-28.03-39.08-67.737H16.963l-22.386 38.789-16.694 28.948 39.128 67.736h-.048Zm236.065.869-39.079-67.737h-78.206l-22.916 39.706-16.163 28.031 39.079 67.688h78.206l39.079-67.688Zm118.733-68.605-19.829-34.351-19.25-33.338h-78.206l-39.079 67.737 39.079 67.737h78.206l39.079-67.737v-.048Zm120.276 67.736h78.206l39.079-67.736-39.079-67.737h-78.206l-39.127 67.737 39.127 67.736Zm236.017.869-29.574-51.237-9.505-16.5h-78.158l-39.078 67.737 39.078 67.688h78.158l39.127-67.688h-.048Zm118.781-68.605-31.842-55.193-7.237-12.544h-78.206l-39.127 67.737 29.574 51.236 9.505 16.5h78.206l39.079-67.736h.048Zm118.732-68.557-31.697-54.904-7.382-12.785h-78.206l-39.079 67.737 31.842 55.193 7.237 12.544h78.206l39.079-67.737v-.048Zm237.514 0-32.71-56.689-6.37-11h-78.21l-39.12 67.737 39.12 67.737H1164l39.08-67.737v-.048Zm118.78-68.557-32.9-57.027-6.18-10.71h-78.21l-19.53 33.868-19.54 33.869 32.75 56.688 6.37 11h78.21l39.08-67.737-.05.049Zm79.65-136.294h-78.2l-19.54 33.868-19.54 33.869 19.54 33.868 19.54 33.868h78.2l39.08-67.736-39.08-67.689v-.048Zm-236.01-.82 19.54 33.868 19.53 33.869h78.21l19.54-33.869 19.54-33.868-39.08-67.737h-78.21l-39.07 67.737Zm-120.23-67.737h-78.208l-19.54 33.868-19.539 33.869 39.079 67.688h78.208l39.13-67.688-39.13-67.737Zm-236.068-.868 19.54 33.868 19.539 33.868h78.206l19.54-33.868 19.539-33.868-39.079-67.737h-78.206l-39.079 67.737Zm-120.228-67.689h-78.158l-19.539 33.868-19.539 33.869 39.078 67.737h78.158l19.54-33.869 19.539-33.868-39.127-67.737h.048Zm-236.065-.868 19.539 33.868 19.54 33.868h78.206l19.539-33.868 19.54-33.868-39.079-67.737h-78.206l-39.128 67.737h.049Zm-118.733 68.557 21.662 37.535 17.465 30.201h78.207l39.078-67.736-19.539-33.869-19.539-33.868h-78.207l-39.078 67.737h-.049ZM213.9-236.106h-78.206l-25.763 44.627-13.316 23.062 39.079 67.736H213.9l25.86-44.82 13.219-22.916-39.079-67.737v.048Zm-236.066-.868 5.21 9.07 33.87 58.666H95.12l25.763-44.627 13.315-23.061-39.079-67.737H16.913l-39.127 67.737.048-.048Zm-118.732 68.557 39.079 67.736h78.206l39.127-67.736-5.21-9.071-33.917-58.666h-78.206l-39.079 67.737ZM-259.63-99.812l39.078 67.688h78.207l25.715-44.482 13.412-23.206-39.127-67.737h-78.207l-39.078 67.737Zm-237.562 0 39.079 67.688h78.206l19.54-33.868 19.539-33.868-39.127-67.737h-78.206L-497.24-99.86l.048.048Zm-118.732 68.557 39.079 67.736h78.206l23.206-40.188 15.873-27.548-39.079-67.737h-78.206l-39.079 67.737Zm-118.78 68.557 39.127 67.688h78.158l22.627-39.127 16.5-28.561-39.127-67.737h-78.158l-39.127 67.737Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#420f63c0-3187-4ee6-9128-8a787d6a4ecb_comp-m7126yt6)",
    d: "m1397.55-92.094 35.13 60.838-35.13 60.838h-70.24l-35.13-60.838 35.13-60.838h70.24Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#18d725e6-4d14-4f71-9063-9167890aaba1_comp-m7126yt6)",
    d: "m685.018-92.094 35.123 60.838-35.123 60.838h-70.246l-35.171-60.838 35.171-60.838h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#200f73f6-0ddb-4cdd-bafe-99bbfb236603_comp-m7126yt6)",
    d: "m1278.82-23.537 35.13 60.838-35.13 60.837h-70.29l-35.12-60.837 35.12-60.838h70.29Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4cbc9cde-0440-4000-a319-b86309c9d258_comp-m7126yt6)",
    d: "m1160.04-92.094 35.12 60.838-35.12 60.838h-70.25l-35.17-60.838 35.17-60.838h70.25Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#558ed2db-ad3d-49a3-adfd-b6fcb985f9a9_comp-m7126yt6)",
    d: "m1160.04 45.02 35.12 60.837-35.12 60.838h-70.25l-35.17-60.838 35.17-60.837h70.25Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#6126cad5-cb3f-4127-910d-660cc8dde725_comp-m7126yt6)",
    d: "m1041.26-23.537 35.17 60.838-35.17 60.837h-70.247L935.89 37.301l35.123-60.838h70.247Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0a6f8f82-b407-4cab-b64f-5f32ca8cfe78_comp-m7126yt6)",
    d: "m922.522 45.02 35.123 60.838-35.123 60.838h-70.246l-35.171-60.838 35.171-60.838h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b9852c8d-43fb-42fe-b0d0-22d2acdaf47f_comp-m7126yt6)",
    d: "M803.744-23.537 838.867 37.3l-35.123 60.837h-70.245L698.376 37.3l35.123-60.838h70.245Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4dcf2bca-c837-4f08-b1d9-9d22b7672ae4_comp-m7126yt6)",
    d: "m803.744 113.576 35.123 60.838-35.123 60.886h-70.245l-35.123-60.886 35.123-60.838h70.245Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d31a1b6c-87c9-46d4-9884-14e83339eb31_comp-m7126yt6)",
    d: "m685.018 182.135 35.123 60.886-35.123 60.837h-70.246l-35.171-60.837 35.171-60.886h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fe31684b-c7e3-42d3-86b1-0439ebe65174_comp-m7126yt6)",
    d: "m566.229 113.576 35.123 60.838-35.123 60.886h-70.246l-35.123-60.886 35.123-60.838h70.246Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dedca586-dec5-478e-a831-7d74c30a0644_comp-m7126yt6)",
    d: "M566.229-23.537 601.352 37.3l-35.123 60.837h-70.246L460.86 37.301l35.123-60.838h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#610b9d06-7446-4145-84cb-4e75cf0d73ac_comp-m7126yt6)",
    d: "m447.454 45.02 35.171 60.838-35.171 60.838h-70.246l-35.122-60.838 35.122-60.838h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#47019102-8c9b-45c3-8a8f-2caea5d8dbc8_comp-m7126yt6)",
    d: "m447.502-92.094 35.123 60.838-35.171 60.837h-70.246l-35.122-60.837 35.122-60.838h70.294Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#716105c0-5aaa-41ae-9920-d34394f82b91_comp-m7126yt6)",
    d: "M91.162-23.537 126.285 37.3 91.162 98.138H20.965L-14.205 37.3l35.17-60.837h70.197Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f4f5b75d-d538-426d-b2e3-29a0502e2afd_comp-m7126yt6)",
    d: "m91.162 113.577 35.123 60.838-35.123 60.886H20.965l-35.17-60.886 35.17-60.838h70.197Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0eeb2520-625e-4c07-aaca-e9aa367683f6_comp-m7126yt6)",
    d: "m209.94-92.094 35.122 60.838L209.94 29.58h-70.246l-35.123-60.837 35.123-60.838h70.246Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#549d7437-cd07-4ebf-bfec-8e1bc1b54e7e_comp-m7126yt6)",
    d: "m328.725 113.577 35.123 60.838-35.123 60.886h-70.246l-35.171-60.886 35.171-60.838h70.246Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#7d6d89be-ffc2-4d63-859f-273316868521_comp-m7126yt6)",
    d: "m209.94 182.134 35.122 60.886-35.122 60.837h-70.246l-35.123-60.837 35.123-60.886h70.246Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed4e4de0-da02-4a31-8261-3d7717033702_comp-m7126yt6)",
    d: "M328.725-23.537 363.848 37.3l-35.123 60.838h-70.246L223.308 37.3l35.171-60.837h70.246Z",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#03c366bf-9be1-4bce-8ad1-94f5567f71d2_comp-m7126yt6)",
    d: "M-7.545 14.964-12.08 7.1l4.535-7.864h9.07l4.101 7.092h78.978l7.43-12.833h14.86l39.464-68.413-4.1-7.092 4.149-7.14-39.465-68.364H92.034l-7.864-13.605 7.864-13.606h15.68l7.864 13.606-7.43 12.833 39.513 68.412h8.202l4.101 7.14h78.978l7.43-12.881h14.859l39.465-68.316-4.149-7.14 4.149-7.14-42.794-74.106H249.7l-4.535-7.864 4.535-7.864h9.022l4.536 7.864-4.101 7.092 42.842 74.154h8.153l4.101 7.092h85.636l4.101-7.092h8.25l39.513-68.364-7.43-12.882 7.864-13.605h15.68l7.864 13.605-7.864 13.606h-14.86l-39.513 68.46 4.053 7.044-4.053 7.044 39.513 68.412h14.812l7.43 12.882h78.978l4.1-7.14h9.071l4.535 7.863-4.101 7.092 39.513 68.413h14.86l7.429 12.833h78.978l4.101-7.092h8.202l42.794-74.154-4.101-7.092 4.535-7.864h9.07l4.535 7.864-4.535 7.864h-8.153L722.218.008l4.101 7.092-4.101 7.092 39.513 68.412h14.859l7.816 13.606-7.816 13.605h-14.859l-39.417 68.315 4.149 7.189-4.149 7.189 42.746 74.057h8.202l4.535 7.864-4.535 7.864h-9.071l-4.535-7.864 4.101-7.092-42.794-74.154h-8.105l-4.101-7.14h-85.636l-4.101 7.14h-8.298l-39.465 68.364 7.43 12.882-7.864 13.605h-15.728l-7.864-13.605 7.864-13.606h14.86l39.561-68.46-4.053-7.044 4.053-7.044-42.89-74.25h-8.202l-4.101-7.092h-78.978l-7.43 12.882h-15.728l-7.864-13.605 7.43-12.882-39.465-68.364h-8.202l-4.101-7.14H314.35l-4.101 7.14h-8.202l-42.842 74.153 4.101 7.093-4.101 7.092 39.513 68.412h14.956l7.864 13.605-7.864 13.605h-15.728l-7.864-13.605 7.382-12.785-39.562-68.461H249.7l-4.1-7.092h-85.636l-4.101 7.092h-8.202l-42.745 74.057 4.149 7.189-4.535 7.864h-9.07l-4.536-7.864 4.535-7.864h8.106l42.793-74.153-4.149-7.14 4.149-7.141-39.464-68.364h-14.86l-7.43-12.882H5.626l-4.1 7.14h-9.07v.049Zm155.158-89.11L108.1-5.733l7.429 12.881L108.1 20.03l39.465 68.364h8.201l4.101 7.14h85.588l4.101-7.14h8.25L300.6 14.24l-4.101-7.092L300.6.056l-39.514-68.412h-14.859l-7.43-12.834h-78.978l-4.101 7.093h-8.202l.097-.049Zm154.337-89.109-39.513 68.412 7.43 12.833-7.43 12.834L301.95-.764h8.202l4.101 7.092h85.636l4.101-7.092h8.202l39.464-68.364-7.429-12.882 7.429-12.881-39.464-68.364h-8.25l-4.101-7.092h-85.636l-4.101 7.092h-8.154Zm151.009 94.85L413.494.008l4.101 7.092-4.101 7.092 39.465 68.364h14.811l7.43 12.882h78.978l4.101-7.14h8.25l39.465-68.365-7.43-12.881 7.43-12.882-39.513-68.412h-8.202l-4.101-7.092H475.2l-7.43 12.833h-14.811v.097Zm154.338 89.11-39.513 68.412 4.1 7.093-4.1 7.092 42.842 74.153h8.298l4.101 7.092h85.636l4.101-7.092h8.105l39.465-68.364-7.43-12.881 7.43-12.882-39.465-68.364h-8.202l-4.101-7.14h-78.978l-7.43 12.881h-14.859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#88865da8-f13b-4c51-9dca-d2952f5fcc73_comp-m7126yt6)",
    d: "m875.199 88.345 42.794-74.153-4.101-7.092 4.101-7.092-42.794-74.154h-8.202l-4.535-7.864 4.535-7.864h8.25l39.465-68.316-7.478-12.929 7.864-13.606h15.728l7.43 12.882h78.974l4.11-7.092h9.07l4.53 7.864-4.1 7.044 39.51 68.412h14.81l7.43 12.881h78.93l4.1-7.14h8.25l42.8-74.105-4.15-7.14 4.53-7.864h9.07l4.54 7.864-4.54 7.815h-8.15l-42.84 74.202 4.1 7.092-4.1 7.044 42.84 74.202h8.2l4.1 7.092h78.98l7.43-12.833h15.73l7.86 13.605-7.86 13.605h-15.73l-7.43-12.882h-78.98l-4.1 7.14h-8.2l-39.51 68.461 7.38 12.785-7.38 12.785 39.56 68.461h8.3l4.53 7.864-4.53 7.864h-9.07l-4.54-7.864 4.05-7.044-39.56-68.46h-14.9l-7.43-12.882h-78.93l-4.1 7.092h-8.21l-39.41 68.316 7.47 12.93-7.81 13.605h-15.73l-7.81-13.605 7.81-13.606h14.76l39.47-68.364-4.1-7.14 4.1-7.14-42.79-74.105h-8.21l-4.1-7.14h-85.585l-4.101 7.14h-8.202L876.55 89.069l4.101 7.092-4.535 7.864h-9.07l-4.535-7.864 4.535-7.864h8.25l-.097.048Zm5.355-170.306-4.1 7.092L919.296-.716h8.201l4.101 7.092h85.632l4.11-7.092h8.2L1069-69.08l-7.43-12.882 7.43-12.881-39.46-68.364h-8.25l-4.1-7.092h-78.982l-7.43 12.881h-14.811l-39.513 68.413 4.1 7.092v-.049ZM1070.3-68.405 1030.79.008l4.1 7.092-4.1 7.092 42.8 74.153h8.2l4.1 7.14h78.88l7.43-12.88h14.96l39.51-68.365-4.1-7.092 4.1-7.092-42.8-74.153h-8.25l-4.1-7.093h-78.97l-7.43 12.834h-14.82v-.049Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ea9cebe3-12c5-41ec-b6b7-3af6830df4e0_comp-m7126yt6)",
    d: "M-348.355 22.007h11.241l5.307 9.215h56.544l2.943-5.114h5.886l30.636-53.07-2.943-5.114 3.232-5.596h6.513l2.943 5.065h61.32l2.943-5.066h5.886l30.684-53.118-2.894-5.017 2.894-5.066-28.32-49.018h-10.662l-5.596-9.745 5.596-9.746h11.241l5.645 9.746-5.307 9.215 28.272 48.969h5.934l2.943 5.114h61.272l2.943-5.114h5.79l30.635-53.07-2.942-5.066 3.232-5.645h6.513l3.232 5.645-3.232 5.596h-5.886l-30.588 53.022 2.992 5.163-2.992 5.162 28.224 48.873h10.614l5.307 9.215h56.544l2.943-5.066h6.465l3.232 5.596-3.232 5.645h-6.465l-2.943-5.114H-.36l-5.307 9.215h-10.614l-28.272 48.969 2.943 5.066-2.943 5.114 28.272 48.97h10.614l5.597 9.745-5.597 9.745h-11.241l-5.645-9.745 5.307-9.215-28.272-48.97h-5.886l-2.943-5.065h-56.544l-5.307 9.215h-10.662l-28.272 48.969 2.943 5.066-3.232 5.596h-6.465l-2.943-5.066h-56.544l-5.307 9.215h-10.614l-28.272 49.018 2.943 5.066-3.232 5.596h-6.465l-3.233-5.596 3.233-5.597h5.886l28.272-48.969-5.356-9.215 5.356-9.215-28.272-48.97h-5.886l-2.943-5.065h-56.544l-5.307 9.215h-11.241L-354 31.849l5.645-9.745v-.097Zm121.723 63.78 5.307 9.216h56.544l2.943-5.066h5.886l28.272-48.97-5.307-9.214 5.307-9.215-28.272-48.97h-5.886l-2.943-5.113h-61.272l-2.943 5.114h-5.886l-30.636 53.118 2.943 5.066-2.943 5.114 28.272 48.97h10.614v-.05Zm110.531-63.78 5.307 9.215h56.496l2.943-5.114h5.885l28.272-48.92-5.355-9.216 5.355-9.215-28.272-48.969h-5.789l-2.943-5.114h-61.32l-2.943 5.114h-5.934l-30.636 53.07 2.943 5.066-2.943 5.066 28.272 48.969h10.662v.048Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c0e338e3-0025-4597-953c-c5dd22e94bbe_comp-m7126yt6)",
    d: "m102.504 26.109 2.942 5.114h56.544l5.307-9.215h10.663l28.272-48.921-2.943-5.114 2.943-5.114-30.636-53.07h-5.79l-3.232-5.597 3.232-5.645h6.513l3.233 5.645-2.991 5.162 30.635 53.022h5.838l2.943 5.066h61.272l2.943-5.066h5.886l28.32-49.017-5.307-9.119 5.645-9.745h11.241l5.645 9.745-5.645 9.746h-10.71l-28.272 48.97 2.943 5.065-2.943 5.066 30.684 53.118h5.886l2.943 5.114h61.32l2.943-5.114h5.886l28.272-48.92-5.307-9.216 5.596-9.745h11.241l5.356 9.215h56.543l2.943-5.066h5.886l30.685-53.119-2.895-5.017 2.895-5.018-28.32-49.017h-10.615l-5.644-9.746 5.644-9.745h11.242l5.596 9.745-5.307 9.215 28.272 48.969h5.982l2.943 5.114h61.321l2.943-5.114h5.837l30.636-53.07-2.943-5.066 3.233-5.644h6.465l3.232 5.644-3.232 5.597h-5.886l-30.588 53.022 2.991 5.162-2.991 5.162 28.224 48.873h10.614l5.596 9.746-5.596 9.745h-10.614l-28.272 48.97 2.943 5.065-2.943 5.114 30.636 53.07h5.837l3.233 5.597-3.233 5.597h-6.513l-3.232-5.597 2.943-5.114-30.636-53.07h-5.886l-2.943-5.066h-56.544l-5.307 9.215h-10.614l-28.272 48.97 2.943 5.065-3.232 5.597h-6.514l-2.943-5.066h-56.543l-5.356 9.215h-10.614l-28.272 49.017 2.895 5.066-2.895 5.066 28.272 49.017h10.614l5.597 9.746-5.597 9.745h-11.241l-5.596-9.745 5.307-9.215-28.272-48.969h-5.934l-2.943-5.066h-61.321l-2.942 5.066h-5.838l-30.684 53.118 2.943 5.066-3.281 5.645h-6.465l-3.232-5.645 3.232-5.597h5.886l30.636-53.07-2.943-5.114 2.943-5.114-28.272-48.921H277.78l-5.355-9.215h-56.544l-2.943 5.066H207.1l-28.272 49.017 5.307 9.167-5.645 9.746h-11.241l-5.596-9.746 5.596-9.745h10.662l28.272-48.97-2.943-5.114 2.943-5.114-28.272-48.969h-10.662l-5.307-9.215h-56.544l-2.943 5.066h-6.513l-3.232-5.597 3.232-5.596h6.513l.049-.241Zm110.482 63.78 2.943 5.066h56.544l5.307-9.215h10.662l28.272-48.97-2.943-5.113 2.943-5.066-30.636-53.118h-5.886l-2.943-5.114h-61.272l-2.943 5.114h-5.838l-28.271 48.969 5.307 9.215-5.307 9.215 28.271 48.97h5.838l-.048.047Zm110.434 63.829 2.943 5.066h61.32l2.943-5.066h5.934l28.272-48.969-5.307-9.215 5.307-9.215-28.272-48.97h-5.886l-2.943-5.065h-61.32l-2.943 5.066h-5.886L289.31 86.32l5.308 9.214-5.308 9.215 28.272 48.969h5.838Zm112.895-67.93 5.355 9.215h56.544l2.943-5.066h5.886l28.272-48.969-5.307-9.215 5.307-9.215-28.272-48.969h-5.886l-2.943-5.114H441.67l-5.355 9.215h-10.614l-28.272 48.97 2.943 5.065-2.943 5.114 28.272 48.97h10.614Zm110.53-63.78 5.307 9.215h56.544l2.943-5.114h5.886l28.224-48.921-5.307-9.215 5.307-9.215-28.224-48.97h-5.838l-2.943-5.114h-61.32l-2.894 5.115h-5.983l-30.684 53.07 2.943 5.066-2.943 5.065 28.272 48.97h10.662l.048.048Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c71574bf-0152-4199-b1d1-9329415c8b27_comp-m7126yt6)",
    d: "m722.119-26.431-3.232-5.645 3.232-5.645h6.465l3.233 5.645-2.895 5.066 30.636 53.118h5.886l2.943 5.114h61.32l2.943-5.114h5.886l30.636-53.07-2.943-5.114 2.943-5.114L840.9-86.16h-10.566l-5.596-9.745 5.596-9.746h11.241l5.597 9.746-5.355 9.263L870.04-37.72h5.838l2.943 5.114h56.544l5.307-9.215h10.71l28.321-49.017-2.895-5.018 3.232-5.644h6.465l3.233 5.644-3.233 5.597h-5.934l-28.32 49.017 5.307 9.167-5.259 9.167 28.272 49.017h5.886l2.943 5.114h56.54l5.31-9.215h11.24l5.65 9.746-5.65 9.745h-11.24l-5.31-9.215H989.4l-2.943 5.066h-5.886l-30.636 53.119 2.943 5.066-2.943 5.065 30.684 53.119h5.838l3.232 5.596-3.232 5.597h-6.465l-3.232-5.597 2.943-5.114-30.636-53.07h-5.886l-2.943-5.066h-56.544l-5.307 9.215h-10.614l-28.272 49.018 2.895 5.065-3.233 5.597h-6.465l-2.943-5.066h-56.544l-5.307 9.215h-11.241l-5.596-9.746 5.355-9.263-28.272-48.921h-5.886l-3.232-5.596 3.232-5.597h5.886l30.636-53.07-2.943-5.114 2.943-5.066-30.636-53.07h-5.886l-.145-.096Zm6.803 127.03 28.272 48.97h10.614l5.307 9.214h56.544l2.943-5.065h5.934l28.272-48.97-5.307-9.215 5.307-9.214-28.272-48.97h-5.838l-2.943-5.066h-61.32l-2.943 5.066h-5.886L728.97 90.468l2.895 5.066-2.895 5.065h-.048ZM878.29 85.788l5.307 9.215h56.544l2.943-5.066h5.886l30.636-53.07-2.943-5.114 2.943-5.066-28.272-48.97h-10.71l-5.307-9.214h-56.496l-2.943 5.114h-5.838l-30.636 53.07 2.943 5.066-2.943 5.114 28.272 48.97h10.614v-.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#9d6c781e-c806-4f8c-b5b9-380729bad382_comp-m7126yt6)",
    d: "M1341.21 45.31h-15.73l-7.43-12.882h-78.88l-4.1 7.093h-8.21l-42.74 74.056 4.1 7.141-4.54 7.864h-9.07l-4.1-7.092h-85.54l-4.1 7.092h-8.25l-42.79 74.153 4.05 7.044-4.24 7.768-1.02.096h-8.29l-4.11-7.092h-85.487l-4.101 7.092h-9.118l-4.439-7.816 4.149-7.188-39.368-68.219h-14.811l-7.43-12.834h-78.882l-4.101 7.092h-9.022l-4.535-7.864 4.535-7.864h9.022l4.101 7.092h78.882l7.43-12.881h14.811l39.417-68.316-4.101-7.092 4.101-7.092-39.465-68.316h-14.812l-7.864-13.605 7.864-13.557h15.68l7.816 13.557-7.43 12.881 39.417 68.316h8.201l4.101 7.092h78.879l7.43-12.833h14.81l39.47-68.364-4.1-7.092 4.53-7.816h9.03l4.1 7.092h78.88l7.43-12.881h14.81l39.46-68.364-4.1-7.044 4.54-7.816h9.07l4.53 7.816-4.53 7.816h-8.25l-39.42 68.315 7.43 12.882-7.43 12.881 39.42 68.316h8.2l4.1 7.092h78.88l7.43-12.833h15.73l7.82 13.605-7.82 13.606.1-.097Zm-169.83-89.013-7.43-12.833h-78.88l-4.1 7.092h-8.2L1033.3 18.87l7.43 12.834-7.43 12.881 39.42 68.316h8.25l4.1 7.092h85.49l4.1-7.092h8.2l42.75-74.057-4.1-7.092 4.1-7.092-39.46-68.316h-14.82l.05-.048ZM1017.19 45.31l-7.43-12.882h-78.882l-4.101 7.093h-8.202l-39.416 68.315 7.429 12.882-7.429 12.881 39.416 68.316h8.105l4.101 7.092h85.539l4.1-7.092h8.3l42.79-74.105-4.1-7.092 4.1-7.092-39.46-68.316h-14.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4ca43dd3-18f8-4b6d-8040-218e3dd395ba_comp-m7126yt6)",
    d: "m712.227 39.569-4.101-7.092h-78.882l-7.429 12.881h-14.86l-39.417 68.268 4.101 7.14-4.101 7.14 42.746 74.057h8.105l4.535 7.816-4.535 7.816h-9.07l-4.535-7.816 4.149-7.188-42.697-73.961h-8.202l-4.101-7.092h-85.539l-4.101 7.092h-8.202l-39.513 68.412 7.381 12.785-7.864 13.606h-15.679l-7.816-13.606 7.816-13.605h14.907l39.465-68.316-4.101-7.092 4.101-7.092-42.793-74.057h-8.202l-4.101-7.092h-85.54l-4.1 7.092h-8.202l-39.417 68.268 7.43 12.881-7.816 13.606h-15.68l-7.429-12.834h-78.882l-4.101 7.092h-8.202l-42.793 74.154 4.052 6.995-4.052 7.044 39.513 68.364h14.811l7.864 13.606-7.864 13.605h-15.68l-7.815-13.605 7.429-12.834-39.416-68.315h-8.299l-4.1-7.093H5.91l-4.1 7.093h-8.106l-42.745 74.056 4.1 7.093-4.535 7.815h-9.021l-4.535-7.815 4.535-7.816h8.201l42.698-73.961-4.15-7.188 4.15-7.189-39.417-68.219h-14.811l-7.864-13.605 7.864-13.606h14.811l39.417-68.315-4.101-7.093 4.1-7.092-42.793-74.105h-8.154l-4.535-7.816 4.535-7.815h9.07l4.536 7.815-4.101 7.14 42.745 74.058h8.202l4.101 7.092H84.89l7.43-12.834h14.859l39.465-68.364-4.101-7.092 4.535-7.815h9.022l4.101 7.092h78.881l7.43-12.882h14.811l39.465-68.364-4.052-7.044 4.052-7.044-39.465-68.364h-14.811l-7.816-13.605 7.816-13.605h15.68l7.816 13.605-7.43 12.834 39.465 68.315h8.25l4.101 7.092h85.539l4.101-7.092h8.105l42.794-74.057-4.101-7.092 4.535-7.816h9.022l4.535 7.816-4.535 7.816h-8.202l-42.745 74.009 4.149 7.14-4.149 7.14 39.417 68.268h14.859l7.43 12.881h78.882l4.1-7.092h8.202l39.465-68.364-7.43-12.785 7.864-13.605h15.68l7.864 13.605-7.864 13.606h-14.908l-39.416 68.267 4.1 7.14-4.1 7.14 39.416 68.317h14.86l7.43 12.833h78.881l4.101-7.092h9.022l4.535 7.816-4.535 7.815h-9.022l-.048-.096ZM558.082-49.444l-4.101-7.092H475.1l-7.43 12.833h-14.86l-39.465 68.316 4.101 7.092-4.101 7.092 42.746 74.057h8.202l4.101 7.092h85.491l4.101-7.092h8.201l39.417-68.316-7.43-12.881 7.43-12.834-39.465-68.315h-8.153l.096.048ZM403.986-138.41l-4.101-7.092h-85.54l-4.1 7.092h-8.25l-39.417 68.316 7.43 12.881-7.43 12.882 39.417 68.315h8.201l4.101 7.093h85.54l4.1-7.093h8.202l39.465-68.315-7.43-12.834 7.43-12.833-39.465-68.316h-8.105l-.048-.096ZM246.464-43.703l-7.43-12.833h-78.881l-4.101 7.092h-8.202L108.385 18.87l7.43 12.834-7.43 12.881 39.465 68.316h8.25l4.101 7.092h78.881l7.43-12.881h14.811l39.417-68.316-4.101-7.092 4.101-7.092-39.465-68.316h-14.811ZM92.319 45.31l-7.43-12.882H6.008l-4.101 7.093h-8.202l-39.416 68.267 7.43 12.882-7.43 12.881 39.416 68.316h8.106l4.1 7.092h85.54l4.1-7.092h8.299l42.794-74.057-4.101-7.092 4.101-7.092-39.465-68.316h-14.86Z"
  })), /*#__PURE__*/React.createElement("defs", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -495.797,
    x2: 801.795,
    y1: 312.398,
    x1: 947.379,
    id: "13b5da39-5533-440a-8487-0dc851ba86f4_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -96.45,
    x2: 1331.5,
    y1: 29.582,
    x1: 1400.75,
    id: "420f63c0-3187-4ee6-9128-8a787d6a4ecb_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -96.47,
    x2: 618.966,
    y1: 29.582,
    x1: 688.207,
    id: "18d725e6-4d14-4f71-9063-9167890aaba1_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.914,
    x2: 1212.77,
    y1: 98.138,
    x1: 1282.01,
    id: "200f73f6-0ddb-4cdd-bafe-99bbfb236603_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -96.47,
    x2: 1093.99,
    y1: 29.582,
    x1: 1163.23,
    id: "4cbc9cde-0440-4000-a319-b86309c9d258_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 40.643,
    x2: 1093.99,
    y1: 166.695,
    x1: 1163.23,
    id: "558ed2db-ad3d-49a3-adfd-b6fcb985f9a9_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.914,
    x2: 975.256,
    y1: 98.138,
    x1: 1044.5,
    id: "6126cad5-cb3f-4127-910d-660cc8dde725_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 40.644,
    x2: 856.47,
    y1: 166.696,
    x1: 925.711,
    id: "0a6f8f82-b407-4cab-b64f-5f32ca8cfe78_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.894,
    x2: 737.691,
    y1: 98.138,
    x1: 806.945,
    id: "b9852c8d-43fb-42fe-b0d0-22d2acdaf47f_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 109.241,
    x2: 737.649,
    y1: 235.3,
    x1: 806.945,
    id: "4dcf2bca-c837-4f08-b1d9-9d22b7672ae4_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 177.78,
    x2: 618.924,
    y1: 303.858,
    x1: 688.207,
    id: "d31a1b6c-87c9-46d4-9884-14e83339eb31_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 109.241,
    x2: 500.133,
    y1: 235.3,
    x1: 569.429,
    id: "fe31684b-c7e3-42d3-86b1-0439ebe65174_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.894,
    x2: 500.176,
    y1: 98.138,
    x1: 569.429,
    id: "dedca586-dec5-478e-a831-7d74c30a0644_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 40.644,
    x2: 381.451,
    y1: 166.696,
    x1: 450.692,
    id: "610b9d06-7446-4145-84cb-4e75cf0d73ac_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -96.471,
    x2: 381.451,
    y1: 29.581,
    x1: 450.692,
    id: "47019102-8c9b-45c3-8a8f-2caea5d8dbc8_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.894,
    x2: 25.109,
    y1: 98.138,
    x1: 94.363,
    id: "716105c0-5aaa-41ae-9920-d34394f82b91_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 109.242,
    x2: 25.067,
    y1: 235.301,
    x1: 94.363,
    id: "f4f5b75d-d538-426d-b2e3-29a0502e2afd_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -96.451,
    x2: 143.887,
    y1: 29.581,
    x1: 213.14,
    id: "0eeb2520-625e-4c07-aaca-e9aa367683f6_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 109.222,
    x2: 262.631,
    y1: 235.301,
    x1: 331.914,
    id: "549d7437-cd07-4ebf-bfec-8e1bc1b54e7e_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 177.799,
    x2: 143.844,
    y1: 303.857,
    x1: 213.14,
    id: "7d6d89be-ffc2-4d63-859f-273316868521_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -27.914,
    x2: 262.673,
    y1: 98.138,
    x1: 331.914,
    id: "ed4e4de0-da02-4a31-8261-3d7717033702_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -343.187,
    x2: 320.935,
    y1: 288.034,
    x1: 603.429,
    id: "03c366bf-9be1-4bce-8ad1-94f5567f71d2_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -215.326,
    x2: 1032.78,
    y1: 198.876,
    x1: 1239.43,
    id: "88865da8-f13b-4c51-9dca-d2952f5fcc73_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -195.239,
    x2: -208.009,
    y1: 165.007,
    x1: -27.25,
    id: "ea9cebe3-12c5-41ec-b6b7-3af6830df4e0_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -218.899,
    x2: 331.226,
    y1: 233.13,
    x1: 533.509,
    id: "c0e338e3-0025-4597-953c-c5dd22e94bbe_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -127.518,
    x2: 840.722,
    y1: 169.108,
    x1: 988.78,
    id: "c71574bf-0152-4199-b1d1-9329415c8b27_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -214.559,
    x2: 1042.08,
    y1: 217.643,
    x1: 1214.9,
    id: "9d6c781e-c806-4f8c-b5b9-380729bad382_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: -318.087,
    x2: 262.837,
    y1: 312.446,
    x1: 545.074,
    id: "4ca43dd3-18f8-4b6d-8040-218e3dd395ba_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79023"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19E1F",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB71B",
    offset: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC963",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A2",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DAD7",
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C5BB",
    offset: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBAA8",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA95",
    offset: 0.771
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009E83",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4197CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8c28189b-78fb-41ef-8ebc-780c05fc8d59_comp-m7126yt6"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 1443.39 0)",
    fill: "#ffffff",
    d: "M1442.54 0v313.596H0V0h1442.54z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrighthiveImage1);
export default __webpack_public_path__ + "static/media/brighthiveImage1.f93a4c79acfb599dcb80320e66b809e5.svg";
export { ForwardRef as ReactComponent };